var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('span',{staticClass:"content"},[[_vm._v("\n    "+_vm._s(_vm.data)+"\n    "),(_vm.content && _vm.content.length > 100)?_c('el-link',{attrs:{"type":"actived","underline":false},on:{"click":function($event){_vm.status=!_vm.status}}},[_vm._v("\n      "+_vm._s(_vm.status?'收起':'展开')+"\n    ")]):_vm._e()]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }